import { useState, useEffect, createContext } from 'react';
import { STEPS } from './steps';
import CartCompact from './CartCompact';
import ProductSelector from './ProductSelector';
import Cart from './Cart';
import Checkout from './Checkout';
import { includes, assign, orderBy, get, fromPairs, uniqBy, sumBy, filter, sortBy, concat, find, sum, map} from 'lodash';
import { loadStripe } from '@stripe/stripe-js/pure';
import ShopMenu from './ShopMenu';
import { WidgetProvider } from './WidgetContext';
import Spinner from './Spinner';


export default function Shop({ slug, ticketing_base_url }) {
    const [loading, setLoading] = useState(true);
    const [step, setStep] = useState(STEPS.PRODUCT_SELECTION);
    const [activeTab, setActiveTab] = useState('all');
    let reverseMobile = false;

    let view;
    if (loading) {
        view = (
            <div className="flex w-full h-full items-center justify-center">
              <div className="bg-blue-500 flex">
                <Spinner/> lade Produkte...
              </div>
            </div>
        );
    } else {
        if (step === STEPS.PRODUCT_SELECTION) {
            let tabView = null;
            reverseMobile = true;
            if (activeTab == 'cart') {
                tabView = (
                    <div className="p-16 flex-1 overflow-scroll">
                      <Cart showAllArticles={false}/>
                    </div>
                );
            } else if (activeTab) {
                tabView = <ProductSelector activeTab={activeTab} />;
            }
            
            view = (
                <>
                  <ShopMenu activeTab={activeTab} setActiveTab={setActiveTab} />
                  {tabView}
                </>
            );
        } else if (step === STEPS.CHECKOUT) {
            view = (
                <>
                  <CartCompact />
                  <Checkout></Checkout>
                </>
            );
        }
    }

    return (
        <div className={`flex ${reverseMobile ? 'flex-col-reverse' : 'flex-col'}  md:flex-row h-full overflow-auto md:overflow-visible`}>
          <WidgetProvider
            loading={loading}
            setLoading={setLoading}
            setStep={setStep}
            slug={slug}
            ticketing_base_url={ticketing_base_url}
          >
            {view}
          </WidgetProvider>
        </div>
    );
}
